import { Directive, ElementRef, HostListener, Input, ViewChild  } from '@angular/core';
import { CommonService } from '../services/common.service';

@Directive({ selector: 'app-input[numbersDotOnly]' })
export class NumDotOnlyDirective {

  @ViewChild('refInput') refInput: ElementRef;
  @Input() numbersDotOnly: string;
  fromMobile: boolean;
  noOfDecimalDigitAllowed: number;
  noOfDecimalDigitEntered = 0;
  digitsLength: number;
  constructor(private _el: ElementRef, private _cs: CommonService) {
    this.fromMobile = this._cs.mobileBrowser;
    this.noOfDecimalDigitAllowed = this._cs.qtyAllowNoOfDecimal;
    this.digitsLength = this._cs.allowNoOfNumericDigitsInField;
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const keyCode = event.which;
    const shiftKey = event.shiftKey;
    const key = event.key;
    const upStartIndex = event.target.selectionStart;
    const upTargetValue = (event.target.value).indexOf('.');
    const currentfieldLength = event.target.value.length;


    // if(upTargetValue != -1){
    //   this.noOfDecimalDigitEntered =(event.target.value.length-1) - upTargetValue;
    // }

    if ((keyCode === 229)
    ) {
      setTimeout(() => {
        const reg = /[^.\d]/g;
        this._el.nativeElement.value = event.target.value.replace(reg, '');
        const patt1 = /[^\d]/g;
          const result = event.target.value.match(patt1);
          let createString = '';
          let decimalCount = 0;
          if (result != null) {
            for (let i = 0; i < event.target.value.length; i++) {
              const currentChar = event.target.value[i];
                if (
                  (currentChar === '0') ||
                  (currentChar === '1') ||
                  (currentChar === '2') ||
                  (currentChar === '3') ||
                  (currentChar === '4') ||
                  (currentChar === '5') ||
                  (currentChar === '6') ||
                  (currentChar === '7') ||
                  (currentChar === '8') ||
                  (currentChar === '9') ||
                  (currentChar === '.' && decimalCount === 0)
                  ) {
                    createString += currentChar;
                    if (currentChar === '.') {
                      decimalCount++;
                    }
                  }
            }
            this._el.nativeElement.value = createString;
          }



      }, 0);
    }

    if (
      ((this.fromMobile ? true : !shiftKey) && keyCode >= 48 && keyCode <= 57 &&
      key !== ')' &&  // 48 -ipad
      key !== '!' &&  // 49-ipad
      key !== '@' &&   // 50-ipad
      key !== '#' &&   // 51-ipad
      key !== '$' &&   // 52-ipad
      key !== '%' &&   // 53-ipad
      key !== '^' &&   // 54-ipad
      key !== '&' &&   // 55-ipad
      key !== '*' &&   // 56-ipad
      key !== '('      // 57-ipad
      ) || // NUMERIC 0 TO 9
      (keyCode >= 96 && keyCode <= 105 ) ||  // NUMERIC 0 TO 9
      keyCode === 8 || // backspace
      keyCode === 9 || // tab
      keyCode === 10 || // line feed
      keyCode === 13 || // enter
      keyCode === 16 || // SHIFT
      keyCode === 17 || // ctrl
      keyCode === 18 || // alt
      keyCode === 20 || // CAPS LOCK
      keyCode === 27 || // escape
      keyCode === 33 || // pageup
      keyCode === 34 || // pagedown
      keyCode === 35 || // end key
      keyCode === 36 || // home key
      (keyCode >= 37 && keyCode <= 40) || // arrow keys

      keyCode === 45 || // insert
      keyCode === 46 || // delete
      (upTargetValue === -1 && (keyCode === 110 || ((this.fromMobile ? true : !shiftKey) && keyCode === 190 && key !== '>') )) ||
      // decimal point //190 -ipad(greater than)
      (keyCode === 112 && keyCode === 123 ) || // f1 to f12
      keyCode === 127 || // delete
      keyCode === 144  // num lock
      ) {
        if (currentfieldLength < this.digitsLength) {
          return true;
        } else {
          if (
            ((keyCode >= 48 && keyCode <= 57 ) || // NUMERIC 0 TO 9
            (keyCode >= 96 && keyCode <= 105 )) // NUMERIC 0 TO 9
          ) {
            return false;
          } else {
            return true;
          }
        }
         /**allow only no of decimal digits */
         /* if(
          upTargetValue !=-1  && //decimal point is present
          ((keyCode >= 48 && keyCode <=57 )|| //NUMERIC 0 TO 9
          (keyCode >= 96 && keyCode <=105 )) //NUMERIC 0 TO 9
           ){
             if(this.noOfDecimalDigitEntered < this.noOfDecimalDigitAllowed){// to check n digits
              this.noOfDecimalDigitEntered++;
              return true;
            }else{
              if(upStartIndex < (upTargetValue+1)){
                return true;
              }else{
                return false;
              }
            }
        } else{
          if((upTargetValue == -1 && (keyCode == 110 || ((this.fromMobile?true:!shiftKey) && keyCode == 190 && key !='>') ))
          // decimal point //190 -ipad(greater than)
             && (upStartIndex < (event.target.value.length-this.noOfDecimalDigitAllowed))
          ){
            return false;
          }else{
            return true;
          }
        }       */
    } else {
      return false;
    }

  }


}
